import useResponsive from '@features/responsive/hooks/useResponsive';
import getCurrentDevice from '@utils/getCurrentDevice';
import getImageSrc from '@utils/getImageSrc';
import SpacingBlock from '@features/cms/components/collections/SpacingBlock/SpacingBlock';
import theme from '@styles/theme';
import styles from './CategoryTilesBlock.styles';
import { ISloganHomeBlock } from '@features/cms/typescript';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
export interface SloganHomeBlockProps {
  data: ISloganHomeBlock;
}
const SloganHomeBlock = ({
  data
}: SloganHomeBlockProps) => {
  const {
    text,
    image,
    code
  } = data;
  const blockData = data as Record<string, unknown>;
  const marginTop = Number(blockData?.marginTop) || 0;
  const marginBottom = Number(blockData?.marginBottom) || 0;
  const spacingBg = blockData?.background as string || theme.rawColors.neutralWhite;
  const {
    currentBreakpoint
  } = useResponsive();
  const currentDevice = getCurrentDevice(currentBreakpoint);
  const imageSrc = image ? getImageSrc(image, currentDevice) : '';
  return <>
      {marginTop > 0 && <SpacingBlock data={{
      type: 'spacingBlock',
      backgroundColor: spacingBg,
      height: String(Number(marginTop)),
      code: 'mt'
    }} />}
      <section sx={{
      ...styles.sectionHeader,
      ...(spacingBg && {
        backgroundColor: spacingBg
      })
    }} data-testid={code}>
        {imageSrc && <ResponsiveImage image={imageSrc} alt={text || ''} sx={styles.headerImage} height={120} width={390} objectFit="contain" />}
        {text && <p sx={styles.description}>{text}</p>}
      </section>
      {marginBottom > 0 && <SpacingBlock data={{
      type: 'spacingBlock',
      backgroundColor: spacingBg,
      height: String(Number(marginBottom)),
      code: 'mb'
    }} />}
    </>;
};
export default SloganHomeBlock;